import React, { useState } from 'react';
import axios from 'axios';
import './Pages.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PRODUCTS = [
  "Ashwagandha Root Powder",
  "Moringa Leaf Powder",
  "Turmeric Powder",
  "Ginger Powder",
  "Amla Powder",
  "Neem Powder",
  "Other (specify in message)"
];

function RequestQuotePage() {
  const [formData, setFormData] = useState({
    full_name: '',
    company_name: '',
    email: '',
    whatsapp: '',
    country: '',
    product: '',
    quantity: '',
    packaging_type: 'Bulk',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await axios.post(`${API}/quote-request`, formData);
      setSubmitStatus({ type: 'success', message: response.data.message });
      setFormData({
        full_name: '',
        company_name: '',
        email: '',
        whatsapp: '',
        country: '',
        product: '',
        quantity: '',
        packaging_type: 'Bulk',
        message: ''
      });
    } catch (error) {
      setSubmitStatus({ type: 'error', message: 'Failed to submit. Please try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="page-container form-page">
      <div className="page-header">
        <h1>Request a Quote</h1>
        <div className="title-underline"></div>
      </div>
      
      <div className="page-intro">
        <p>Share your requirement and our team will provide pricing and export options based on your quantity, packaging, and destination country.</p>
      </div>

      {submitStatus?.type === 'success' ? (
        <div className="success-message">
          <div className="success-icon">✓</div>
          <h3>Thank you!</h3>
          <p>{submitStatus.message}</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="request-form">
          <div className="form-row">
            <div className="form-group">
              <label>Full Name *</label>
              <input type="text" name="full_name" value={formData.full_name} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Company Name</label>
              <input type="text" name="company_name" value={formData.company_name} onChange={handleChange} />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Email *</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>WhatsApp Number *</label>
              <input type="tel" name="whatsapp" value={formData.whatsapp} onChange={handleChange} required placeholder="+1234567890" />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Country *</label>
              <input type="text" name="country" value={formData.country} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Product Interested In *</label>
              <select name="product" value={formData.product} onChange={handleChange} required>
                <option value="">Select Product</option>
                {PRODUCTS.map(p => <option key={p} value={p}>{p}</option>)}
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Required Quantity *</label>
              <input type="text" name="quantity" value={formData.quantity} onChange={handleChange} required placeholder="e.g., 100 kg, 1 MT" />
            </div>
            <div className="form-group">
              <label>Packaging Type *</label>
              <select name="packaging_type" value={formData.packaging_type} onChange={handleChange} required>
                <option value="Bulk">Bulk (25kg bags/drums)</option>
                <option value="Private Label">Private Label (100g/250g packs)</option>
                <option value="Both">Both</option>
              </select>
            </div>
          </div>

          <div className="form-group full-width">
            <label>Message / Special Requirements</label>
            <textarea name="message" value={formData.message} onChange={handleChange} rows="4" placeholder="Any specific requirements..."></textarea>
          </div>

          {submitStatus?.type === 'error' && (
            <div className="error-message">{submitStatus.message}</div>
          )}

          <button type="submit" className="btn-submit" disabled={isSubmitting}>
            {isSubmitting ? 'Submitting...' : 'Submit Request'}
          </button>
        </form>
      )}
    </div>
  );
}

export default RequestQuotePage;
